import { Observable, of } from 'rxjs'
import { CanvasService } from '../canvas.service'
import { CanvasArgs, CanvasBaseCommand, CanvasCommandType } from './canvas-command.model'

export interface UndoDiagramArgs extends CanvasArgs {
  /** Client-side delegate that performs the undo on the diagram. */
  action?: () => void
}

export class UndoDiagramCommand extends CanvasBaseCommand<UndoDiagramArgs> {
  readonly id = 'undo'
  readonly type: CanvasCommandType = 'invoker'
  override icon = 'undo'
  override label = 'Undo'
  override tooltip = 'Undo (Ctrl+Z)'

  constructor(canvasService: CanvasService) {
    super(canvasService)
  }

  override enabled(args?: UndoDiagramArgs): boolean {
    return !!args?.canvasId && !!args?.canUndo
  }

  protected doExecute(args?: UndoDiagramArgs): Observable<boolean> {
    args?.action?.()
    return of(true)
  }
}
